import type { SupportedLocale } from "../i18n";

const localeMap: Record<SupportedLocale, string> = {
  ar: "ar-SA",
  en: "en-SA",
};

export const formatSar = (value: number, locale: SupportedLocale) =>
  new Intl.NumberFormat(localeMap[locale], {
    style: "currency",
    currency: "SAR",
    currencyDisplay: "symbol",
  }).format(value);

export const formatRiyadhDate = (value: Date, locale: SupportedLocale) =>
  new Intl.DateTimeFormat(localeMap[locale], {
    dateStyle: "long",
    timeZone: "Asia/Riyadh",
  }).format(value);
